import React, { ReactNode } from "react";
import { Modal as ReactModal } from "react-responsive-modal";
import styled, { createGlobalStyle, css } from "styled-components";

interface ModalProps {
  isOpen: boolean;
  maxWidth?: number;
  children?: ReactNode;
  onRequestClose: () => void;
}

const Modal = ({
  isOpen,
  children,
  maxWidth = 800,
  onRequestClose,
}: ModalProps) => {
  return (
    <>
      <GlobalStyles maxWidth={maxWidth} />
      <ReactModal
        closeOnOverlayClick={false}
        open={isOpen}
        showCloseIcon={false}
        onClose={onRequestClose}
        styles={{
          modal: {
            maxWidth: maxWidth || 800,
          },
        }}
        classNames={{
          overlay: "customOverlay",
          modal: "modalContainer",
        }}
      >
        {children}
      </ReactModal>
    </>
  );
};

const GlobalStyles = createGlobalStyle<{
  maxWidth: number;
}>`
    .modalContainer {
      border-radius: 15px;
      border: 1px solid #ccc;
      padding: 25px;
      overflow-y: visible;
      box-sizing: border-box;
      margin: 25px;
      padding: 25px;
      width: calc(100% - 25px - 25px);
    }

`;

export default Modal;
